RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.Review = Marionette.ItemView.extend({
        tagName: 'span',
        className: 'label label-important x-under-review-label',
        template: '#reviewTemplate'
    });
});
